var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamsJoined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_170107",
    "data-name": "Group 170107",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150969",
    "data-name": "Rectangle 150969",
    width: 80,
    height: 80,
    rx: 12,
    fill: "rgba(13,75,76,0.1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_people",
    "data-name": "vuesax/bold/people",
    transform: "translate(-600 -232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "people",
    transform: "translate(620 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H40V40H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.983,9.617a1.231,1.231,0,0,0-.35,0,4.825,4.825,0,1,1,.35,0Z",
    transform: "translate(24.233 3.333)",
    fill: "#0d4b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M6.983,7.821a10.349,10.349,0,0,1-6.9,1.4,10.885,10.885,0,0,0,.983-4.483A10.241,10.241,0,0,0,0,.1,10.4,10.4,0,0,1,6.967,1.488C9.6,3.221,9.6,6.071,6.983,7.821Z",
    transform: "translate(27.667 16.679)",
    fill: "#0d4b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M4.633,9.617a1.231,1.231,0,0,1,.35,0,4.808,4.808,0,1,0-.35,0Z",
    transform: "translate(6.1 3.333)",
    fill: "#0d4b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M7.592,4.738a10.854,10.854,0,0,0,.983,4.533,10.3,10.3,0,0,1-6.6-1.433c-2.633-1.75-2.633-4.6,0-6.35A10.235,10.235,0,0,1,8.642.071,10.6,10.6,0,0,0,7.592,4.738Z",
    transform: "translate(3.325 16.679)",
    fill: "#0d4b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M5.95,11.45a1.882,1.882,0,0,0-.433,0,5.75,5.75,0,1,1,.433,0Z",
    transform: "translate(14.25 15)",
    fill: "#0d4b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M1.887,1.437c-2.517,1.683-2.517,4.45,0,6.117a10.184,10.184,0,0,0,10.433,0c2.517-1.683,2.517-4.45,0-6.117A10.184,10.184,0,0,0,1.887,1.437Z",
    transform: "translate(12.896 28.463)",
    fill: "#0d4b4c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsJoined);
export default __webpack_public_path__ + "static/media/teams-joined.63cd441cafcd2b58e896e75e6225fdd5.svg";
export { ForwardRef as ReactComponent };